<template>
  <div>
    <custom-page-table
      ref="tableList"
      :queryParams="queryParams"
      :columns="columns"
      base-key="smsUrl"
      params-path="template/getTemplateInfoPage"
    >
    <span slot="action" slot-scope="rowItem">
      <a v-if="rowItem.record.templateStatus===1|| rowItem.record.templateStatus===5"
         @click="closeOrOpenTemplate(rowItem.record,4)">开启</a>
      <a v-if="rowItem.record.templateStatus===4" style="color: red"
         @click="closeOrOpenTemplate(rowItem.record,5)">关闭</a>
    </span>
    </custom-page-table>
  </div>
</template>

<script>
export default {
  name: 'SmsShieldingSendComponent',
  data() {
    return {
      columns: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '模板标题',
          dataIndex: 'templateTitle'
        },
        {
          title: '短信模板内容',
          dataIndex: 'templateContent',
          width: '45%'
        },
        {
          title: '模板来源',
          dataIndex: 'templateSourceStr'
        },
        {
          title: '提交时间',
          dataIndex: 'createTime'
        },
        {
          title: '状态',
          dataIndex: 'templateStatusStr'
        },
        {
          title: '备注',
          dataIndex: 'templateRemarks'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '80px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
  },
  created() {
    let platformConfig = this.getPlatformConfig()
    const userInfo = this.$store.getters.userInfo
    this.queryParams = {
      merchantId: this.merchantId,
      platformId: this.platformId
    }
  },
  methods: {
    closeOrOpenTemplate(item, templateStatus) {
      this.getHttpServices().getSmsApiService().post('template/closeOrOpenTemplate', {
        templateId: item.templateId,
        templateStatus: templateStatus,
        templateType: item.templateSource,
        merchantId: this.merchantId,
        platformId: this.platformId
      })
        .then(res => {
          if (res === 1) {
            let tips = templateStatus === 4 ? '开启成功' : '关闭成功'
            this.$message.success(tips)
            this.$refs.tableList.refresh(true)
          } else {
            let tips = templateStatus === 4 ? '开启失败' : '关闭失败'
            this.$message.error(tips)
          }
          this.getLogUtils().logWithTag('closeOrOpenTemplate', res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    searchBts() {
      this.$refs.tableList.refresh(true)
    }
  }
}
</script>
<style scoped>

</style>